<template>
  <router-link
    class="text-deco"
    :to="{
      name: 'product-detail',
      params: {
        slug: product.product_slug_name,
        id: product.product_id,
      },
    }"
  >
    <v-card
      outlined
      class="rounded-lg border-yellow" style="height: 100%;"
      :elevation="hover ? 4 : 0"
    >
      <div>
        <v-img
          :src="
            product.product_image[0]
              ? product.product_image[0]
              : '/assets/product/default.png'
          "
          height="180"
          class="rounded-t-lg"
        ></v-img>
      </div>
      <v-col class="grey--text text--darken-2 px-2">
        <div class="text-body-2 product-name">
          {{ product.product_name }}
        </div>
        <div class="product-price mt-2">
          <div
            class="text-decoration-line-through font-size-12 pink--text"
            v-if="product.product_price != product.product_price_origin"
          >
            Rp {{ product.product_price_origin | toNumber }}
          </div>
          <div class="text-subtitle-1 pt-1 font-weight-bold">
            Rp {{ product.product_price | toNumber }}
            <small
              v-if="product.product_enable_discount == '1'"
              class="red darken-4 px-1 white--text"
              >{{ product.product_discount_percent | toNumber }}%</small
            >
          </div>
        </div>
        <div class="text-caption">
          <!-- <span
            v-if="product.product_enable_discount == '1'"
            class="red white--text"
            >{{ product.product_discount_percent | toNumber }}%</span
          > -->
          <!-- &nbsp; -->
          <strike v-if="product.product_enable_discount == '1'"
            >Rp {{ product.product_gross | toNumber }}</strike
          >
        </div>
        <!-- <div v-if="false">
          <v-icon
            small
            color="yellow darken-1"
            v-for="i in fullRating(product.product_rating)"
            :key="'full' + i"
            >mdi-star</v-icon
          >
          <v-icon
            small
            color="yellow darken-1"
            v-if="
              halfRating(product.product_rating, product.product_review_count)
            "
            >mdi-star-half-full</v-icon
          >
          <v-icon
            small
            color="yellow darken-1"
            v-for="i in nullRating(product.product_rating)"
            :key="'half' + i"
            >mdi-star-outline</v-icon
          >       <span class="pl-1 text-caption"
            >({{ product.product_review_count | toNumber }})</span
          >
        </div> -->
        <div class="text-caption my-1" v-if="product.am.product_fee > 0">
          <b class="gm-tag rounded pa-1"
            >GM: Rp {{ product.am.total | toNumber }}</b
          >
        </div>
        <div v-if="!city" class="text-caption">
          <span>{{ product.product_sold_count | toNumber }} terjual</span>
        </div>
        <small v-else class="black--text text--darken-2">
            <v-icon>mdi-map-marker</v-icon>
            {{ product.store_city_name }} 
        </small> 
      </v-col>
    </v-card>
  </router-link>
</template>

<script>
export default {
  props: {
    product: Object,
    hover: {
      type: Boolean,
      default: () => false,
    },
    city: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.gm-tag{
    background-color: #f8c114;
    color: #fff;
}
</style>